import outlet from "fragments/news/outlet"
import { gql } from "graphql-tag"

const GET_OUTLET_BY_ID = gql`
  ${outlet}

  query getOutletById($id: ID!) {
    getOutletById(id: $id) {
      ...Outlet
    }
  }
`

export default GET_OUTLET_BY_ID
